import React from 'react';
import { textStyles } from '@allenai/varnish';
import { Parser, HtmlRenderer } from 'commonmark';
import styled from 'styled-components';

interface Props {
    children: string;
    className?: string;
}

export const Markdown = ({ children, className }: Props) => {
    const reader = new Parser({ smart: true });
    const writer = new HtmlRenderer({ safe: true });
    const parsed = reader.parse(children);
    const html = writer.render(parsed);
    // The `<MarkdownContainer />` extends `<Body />` which by default uses a `<p />` tag.
    // Markdown can result in `<p />` tags as children, which is invalid HTML, as a `<p />` tag
    // cannot be nested in a `<p />` tag. This in turn breaks React's ability to reconcile the
    // resulting DOM, which can cause unexpected outcomes.
    // See: https://github.com/facebook/react/issues/5479
    return (
        <MarkdownContainer
            as="div"
            className={className}
            dangerouslySetInnerHTML={{ __html: html }}
        />
    );
};

// NOTE: Tables and Strikethrough don't work
const MarkdownContainer = styled(textStyles.Normal)`
    p {
        &:first-child {
            margin-top: 0;
        }
        &:last-child {
            margin-bottom: 0;
        }
    }
    img {
        max-width: 100%;
    }
    img[src*='#thumbnail'] {
        width: ${({ theme }) => theme.spacing.xl3};
    }
    ol,
    ul {
        margin-bottom: ${({ theme }) => theme.spacing.md};
    }
    ul {
        list-style-type: revert;
    }
    li > p {
        margin-bottom: 0;
    }
`;
